import { render, staticRenderFns } from "./WarningBanner.vue?vue&type=template&id=3cb252fb&scoped=true"
import script from "./WarningBanner.vue?vue&type=script&lang=ts"
export * from "./WarningBanner.vue?vue&type=script&lang=ts"
import style0 from "./WarningBanner.vue?vue&type=style&index=0&id=3cb252fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb252fb",
  null
  
)

export default component.exports